import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { IUserDetails } from 'typings/api-customer';
import { OrganizationUnitUsersListState, OrganizationUnitUsersListStore } from './organization-unit-users-list.store';

@Injectable({ providedIn: 'root' })
export class OrganizationUnitUsersListQuery extends QueryEntity<OrganizationUnitUsersListState, IUserDetails> {
  constructor(protected store: OrganizationUnitUsersListStore) {
    super(store);
  }

  getMetadata() {
    return this.select((value) => ({
      total: value.total,
      skip: value.skip,
      limit: value.limit,
      query: value.query,
    }));
  }
}
